/**
 * @export 暴露出使用downLoadAll组件的弹窗配置项
 * */

import IP_B_PLATFORM_RETURN_ORDER from './IP_B_PLATFORM_RETURN_ORDER.js'

import IP_B_CANCEL_TIME_ORDER_VIP from './IP_B_CANCEL_TIME_ORDER_VIP.js'
import IP_B_JINGDONG_DIRECT from './IP_B_JINGDONG_DIRECT.js'
import IP_B_JINGDONG_ORDER from './IP_B_JINGDONG_ORDER.js'
import IP_B_JINGDONG_REFUND from './IP_B_JINGDONG_REFUND.js'
import IP_B_JINGDONG_SA_REFUND from './IP_B_JINGDONG_SA_REFUND'
import IP_B_JITX_DELIVERY from './IP_B_JITX_DELIVERY.js'
import IP_B_JITX_ORDER from './IP_B_JITX_ORDER.js'
import IP_B_PLATFORM_ORDER from './IP_B_PLATFORM_ORDER.js'
import IP_B_PLATFORM_ORDER_SOURCE from './IP_B_PLATFORM_ORDER.js'
import IP_B_STANDPLAT_ORDER from './IP_B_STANDPLAT_ORDER.js'
import IP_B_TAOBAO_EXCHANGE from './IP_B_TAOBAO_EXCHANGE.js'
import IP_B_TAOBAO_ORDER from './IP_B_TAOBAO_ORDER.js'
import AC_F_ALIPAY_BILL_RAW_DATA from './AC_F_ALIPAY_BILL_RAW_DATA.js'
import IP_B_TAOBAO_REFUND from './IP_B_TAOBAO_REFUND.js'
import IP_B_TIME_ORDER_VIP from './IP_B_TIME_ORDER_VIP.js'
import IP_B_VIP_RETURN_ORDER from './IP_B_VIP_RETURN_ORDER.js'
import IP_C_TAOBAO_PRODUCT from './IP_C_TAOBAO_PRODUCT.js'

import IP_B_TAOBAO_FX_ORDER from './IP_B_TAOBAO_FX_ORDER.js'
import IP_B_STANDPLAT_REFUND from './IP_B_STANDPLAT_REFUND.js'
import IP_B_TAOBAO_FX_REFUND from './IP_B_TAOBAO_FX_REFUND.js'
import IP_C_STANDPLAT_PRO from './IP_C_STANDPLAT_PRO.js'
import IP_C_VIP_PRO from './IP_C_VIP_PRO.js'

/* 2.0: */
import OC_B_VIPCOM_PO from './OC_B_VIPCOM_PO.js'
import PS_C_SKU from './PS_C_SKU.js'

import AC_F_PLATFORM_BILL from '../../financeCenter/AC_F_PLATFORM_BILL.js'
import AC_F_DOUYIN_ORIGINAL_BILL from './AC_F_DOUYIN_ORIGINAL_BILL.js'
import IP_C_PRODUCT_DOWNLOAD from './IP_C_PRODUCT_DOWNLOAD.js'

export default () => ({
  IP_C_PRODUCT_DOWNLOAD: IP_C_PRODUCT_DOWNLOAD(),
  AC_F_DOUYIN_ORIGINAL_BILL: AC_F_DOUYIN_ORIGINAL_BILL(),
	IP_B_TAOBAO_FX_ORDER: IP_B_TAOBAO_FX_ORDER(),
	IP_B_TAOBAO_JX_ORDER: IP_B_TAOBAO_FX_ORDER(),
	IP_B_STANDPLAT_REFUND: IP_B_STANDPLAT_REFUND(),
	IP_B_TAOBAO_FX_REFUND: IP_B_TAOBAO_FX_REFUND(),
	IP_C_STANDPLAT_PRO: IP_C_STANDPLAT_PRO(),
	IP_B_JINGDONG_DIRECT: IP_B_JINGDONG_DIRECT(),
	IP_B_JINGDONG_ORDER: IP_B_JINGDONG_ORDER(),
	IP_B_CANCEL_TIME_ORDER_VIP: IP_B_CANCEL_TIME_ORDER_VIP(),
	IP_B_JINGDONG_REFUND: IP_B_JINGDONG_REFUND(),
	IP_B_JINGDONG_SA_REFUND: IP_B_JINGDONG_SA_REFUND(),
	IP_B_JITX_DELIVERY: IP_B_JITX_DELIVERY(),
	IP_B_JITX_ORDER: IP_B_JITX_ORDER(),
  IP_B_PLATFORM_ORDER_SOURCE: IP_B_PLATFORM_ORDER_SOURCE(),
  IP_B_PLATFORM_ORDER: IP_B_PLATFORM_ORDER(),
	IP_B_STANDPLAT_ORDER: IP_B_STANDPLAT_ORDER(),
	IP_B_TAOBAO_EXCHANGE: IP_B_TAOBAO_EXCHANGE(),
	IP_B_TAOBAO_ORDER: IP_B_TAOBAO_ORDER(),
	IP_B_TAOBAO_REFUND: IP_B_TAOBAO_REFUND(),
	IP_B_TIME_ORDER_VIP: IP_B_TIME_ORDER_VIP(),
	IP_B_VIP_RETURN_ORDER: IP_B_VIP_RETURN_ORDER(),
	IP_C_TAOBAO_PRODUCT: IP_C_TAOBAO_PRODUCT(),
	/* 2.0: */
  IP_B_PLATFORM_RETURN_ORDER: IP_B_PLATFORM_RETURN_ORDER(),
	OC_B_VIPCOM_PO: OC_B_VIPCOM_PO(),
	PS_C_SKU: PS_C_SKU(),
	AC_F_PLATFORM_BILL: AC_F_PLATFORM_BILL(),
	IP_C_VIP_PRO: IP_C_VIP_PRO(),
	AC_F_ALIPAY_BILL_RAW_DATA: AC_F_ALIPAY_BILL_RAW_DATA()
})
